import { capitalizeFirstLetterAndRemainingSmallForEachWord } from "../../../utils/commonUtils";

type BarData = {
  [key: string]: string;
};

type Props = { dynamicColumns: string[]; barData: BarData[] };

const OverallAnalysisTable = ({ dynamicColumns, barData }: Props) => {
  return (
    <div className="pt-4 mx-4 font-poppins mb-5">
      <div className="overflow-x-auto">
        <table className="min-w-full border-collapse border border-gray-300 rounded-md">
          {/* Table Header */}
          <thead className="font-bold text-gray-800 text-left">
            <tr>
              <th className="p-2 border border-gray-300 text-center">
                Trend No.
              </th>
              <th className="p-2 border border-gray-300 text-center">
                Contribution
              </th>
              <th className="p-2 border border-gray-300 text-center">Impact</th>
              {/* <th className="p-2 border border-gray-300 text-center">Bet</th> */}
              {dynamicColumns.map((column, index) => (
                <th
                  key={index}
                  className="p-2 border border-gray-300 text-center"
                >
                  {column}
                </th>
              ))}
            </tr>
          </thead>
          {/* Table Body */}
          <tbody>
            {barData.map((row, index) => (
              <tr key={index} className="border border-gray-300 text-center">
                <td className="p-2 border border-gray-300 text-center">
                  {row.tNo}
                </td>
                <td className="p-2 border border-gray-300 text-center">
                  {Number(row.contribution).toFixed(2)}
                </td>
                <td className="p-2 border border-gray-300 text-center">
                  {capitalizeFirstLetterAndRemainingSmallForEachWord(
                    row.impact
                  )}
                </td>
                {/* <td className="p-2 border border-gray-300 text-center">
                  {row.bet}
                </td> */}
                {dynamicColumns.map((column, index) => (
                  <td
                    key={index}
                    className="p-2 border border-gray-300 text-center"
                  >
                    {typeof row[column] === "string"
                      ? capitalizeFirstLetterAndRemainingSmallForEachWord(
                          row[column]
                        )
                      : column === "Impact Score"
                        ? Number(row[column]).toFixed(0)
                        : Number(row[column]).toFixed(2)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default OverallAnalysisTable;
